import { createFilter, createSorter } from 'components/Tables/ColumnCreationHelper';
import { t } from 'i18next';
import { AppTableFilters } from 'services/AppTableFilters';
import { ITrackingDiagnostic } from 'types/models/TrackingDiagnosticsModel';
import { filterHasTrackingDiagnosticsHasFile, filterHasTrackingDiagnosticsSessionType, filterHasTrackingDiagnosticsType, getBooleanArrayFilterOptions, getStringArrayFilterOptions } from 'utilities/FilterUtils';

export const appTableFiltersInstance = new AppTableFilters(100);

export const trackingDiagnosticsTableColumns = (trackingDiagnosticsTypes: string[], trackingDiagnosticsSessionTypes: string[]) => [
    {
        id: 'trackingDiagnosticHasFile',
        Header: t('TrackingDiagnostics.Column.HasFile'),
        accessor: 'hasFile',
        maxWidth: 50,
        sorter: createSorter(appTableFiltersInstance, 'hasFile', 'number'),
        filter: createFilter(
            appTableFiltersInstance,
            'select',
            "hasFile",
            t('TrackingDiagnostics.Column.HasFile'),
            getBooleanArrayFilterOptions(),
            (item: ITrackingDiagnostic, value: string) => filterHasTrackingDiagnosticsHasFile(value, item)),
    },
    {
        id: 'trackingDiagnosticId',
        Header: t('TrackingDiagnostics.Column.Id'),
        accessor: 'id',
        maxWidth: 50,
        filter: createFilter(
            appTableFiltersInstance,
            'textfields',
            "id",
            t('TrackingDiagnostics.Column.Id'),
        )
    },
    {
        id: 'trackingDiagnosticOrganizationName',
        Header: t('organizationName'),
        accessor: 'organizationName',
        maxWidth: 70,
        sorter: createSorter(appTableFiltersInstance, 'organizationName', 'text'),
        filter: createFilter(
            appTableFiltersInstance,
            'textfields',
            "organizationName",
            t('organizationName'),
        )
    },
    {
        id: 'trackingDiagnosticType',
        Header: t('TrackingDiagnostics.Column.Type'),
        accessor: 'type',
        maxWidth: 40,
        sorter: createSorter(appTableFiltersInstance, 'type', 'text'),
        filter: createFilter(
            appTableFiltersInstance,
            'multioption',
            "type",
            t('TrackingDiagnostics.Column.Type'),
            getStringArrayFilterOptions(trackingDiagnosticsTypes),
            (item, value: string[]) => {
                return !!filterHasTrackingDiagnosticsType(value, item);
            })
    },
    {
        id: 'trackingDiagnosticSessionType',
        Header: t('TrackingDiagnostics.Column.SessionType'),
        accessor: 'sessionType',
        maxWidth: 50,
        sorter: createSorter(appTableFiltersInstance, 'sessionType', 'text'),
        filter: createFilter(
            appTableFiltersInstance,
            'multioption',
            "sessionType",
            t('TrackingDiagnostics.Column.SessionType'),
            getStringArrayFilterOptions(trackingDiagnosticsSessionTypes),
            (item, value: string[]) => {
                return !!filterHasTrackingDiagnosticsSessionType(value, item);
            })
    },
    {
        id: 'trackingDiagnosticDescription',
        Header: t('TrackingDiagnostics.Column.Description'),
        accessor: 'description',
        maxWidth: 70,
        filter: createFilter(
            appTableFiltersInstance,
            'textfields',
            "description",
            t('TrackingDiagnostics.Column.Description'),
        )
    },
    {
        id: 'trackingDiagnosticRadarSerial',
        Header: t('TrackingDiagnostics.Column.RadarSerial'),
        accessor: 'radarSerial',
        maxWidth: 40,
        sorter: createSorter(appTableFiltersInstance, 'addedAtUtc', 'date'),
        filter: createFilter(
            appTableFiltersInstance,
            'textfields',
            "radarSerial",
            t('TrackingDiagnostics.Column.RadarSerial'),
        )
    },
    {
        id: 'trackingDiagnosticAddedAtUtc',
        Header: t('TrackingDiagnostics.Column.AddedAt'),
        accessor: 'addedAtUtc',
        maxWidth: 40,
        sorter: createSorter(appTableFiltersInstance, 'addedAtUtc', 'date'),
        filter: createFilter(
            appTableFiltersInstance,
            'textfields',
            "addedAtUtc",
            t('TrackingDiagnostics.Column.AddedAt'),
        )
    },
    {
        id: 'actions',
        Header: t('actions'),
        maxWidth: 50,
    },
];
